import { Skeleton, Button } from '../../ui';

const WebHooks = ({ loading, url, onEditClick }) => (
  <div className="space-y-3">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-0">
        <p className="form-label mb-1">URL</p>
        {loading ? (
          <Skeleton w="16rem" h="0.9rem" />
        ) : (
          <p className="break-all font-medium text-theme-headings dark:text-themedark-headings">
            {url || 'No webhook URL set'}
          </p>
        )}
      </div>
      <Button variant="outline-primary" size="sm" onClick={onEditClick} disabled={loading}>
        {url ? 'Edit' : 'Set URL'}
      </Button>
    </div>

    <p className="text-sm text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
      Deliveries are attempted once. There are no retries and no idempotency key, so a webhook your endpoint misses is
      lost — reconcile against the transaction list rather than relying on delivery.
    </p>
  </div>
);

export default WebHooks;
